module.exports = __webpack_public_path__ + "static/media/exc_lad_acc.32999db6.png";